export const CartActionTypes = {
    SET_CART_ITEMS: "SET_CART_ITEMS",
    GET_CART: "GET_CART",
    SET_GRAND_TOTAL: "SET_GRAND_TOTAL",
    SET_CHECKOUT_ID: "SET_CHECKOUT_ID",
}